export function browserSupportsWebSockets() {
  return 'WebSocket' in window;
}
